export default {
  title: 'Export & Download History',
  desc: 'View the export, download and application history of projects.',
  exportExc: 'Export Excel',
  tab1: 'Playable Projects',
  tab2: 'Video Projects',
  tab3: 'Screen Recording Projects',
  tab4: 'AI Projects',
  record: {
    state: {
      success: 'Export Succeeded',
      exporting: 'Exporting',
      fail: 'Export Failed',
    },
    select: {
      name: 'Work Name',
      projectId: 'Project ID',
      projectName: 'Project Name',
      versionId: 'Version ID',
      versionName: 'Version Name',
    },
    table: {
      name: 'Work Name',
      state: 'Export Status',
      operation: {
        name: 'Operations',
        again: 'Re-Export',
        look: 'Preview',
        down: 'Download',
      },
      exportTime: 'Export Time',
      updateTime: 'Updated Time',
      nameId: 'Project Name and ID',
      versionId: 'Version Name and ID',
      material: {
        id: 'Creative ID',
        unsupportAnalyze:
          'This creative does not support the analysis function.',
        analyze: 'Creative Analyze',
      },
    },
  },
  video: {
    state: {
      success: 'Export Succeeded',
      exporting: 'Exporting',
      fail: 'Export Failed',
      waiting: 'Waiting in Queue',
      queuing: 'Queuing',
      completed: 'Completed',
      partSuccesss: 'Partially Successful',
    },
    select: {
      name: 'Work Name',
      id: 'Project ID',
      projectName: 'Product Name',
      exportId: 'Export Task ID',
      nameId: 'Work ID',
    },
    table: {
      name: 'Work Name and ID',
      stats: 'Export Status',
      operations: 'Operations',
      ProjectId: 'Project Name and ID',
      size: 'Dimension',
      resolution: 'Resolution',
      fileSize: 'Size',
      number: 'Successfully Apply',
      exportTime: 'Export Time',
      operation: {
        lookProject: 'Preview Work',
        downProject: 'Download Work',
        Mintegral: 'Apply to Mintegral',
      },
      pushId: 'Application ID',
      exportStatus: 'Mission status',
      pushVideoCounts: 'Number of videos pushed',
      pushCounts: 'Number of push',
      exportCount: 'Number of exports',
      pushAgain: 'Push Again',
      batchDownload: 'Bulk download',
      downProject: 'Download Work',
      cancelExport: 'Cancel Export',
      cancelMainTitle: 'Are you sure to cancel the work in the queue?',
      cancelSubTitle:
        'After confirming that the export is canceled, the work will not be exported again.',
      againMainTitle: 'Are you sure to re-export the failed works?',
      againSubTitle:
        'After confirming the re-export, the work will be added to the export queue again.',
      verificationName:
        'Some names of works do not meet the requirements and can only contain numbers, letters and underscores. Please modify the names in batches and then push again',
      batchRename: 'Batch naming',
      example: 'Demonstrate',
      newProject: 'Create Project',
    },
    push: {
      channel: 'Apply to',
      name: 'Name',
      username: 'Only Accounts Can Apply',
    },
    history: {
      table: {
        name: 'Work Name',
        state: 'Apply Status',
        operations: 'Operations',
        channel: 'Ad Networks',
        username: 'Account',
        data: 'Date',
      },
      push: {
        state: {
          success: 'Push Successfully',
          feld: 'Push Failed',
          ing: 'Applying',
        },
        Mintegral: 'Apply to Mintegral',
      },
    },
    table1: 'Export Tasks',
    table2: 'Works',
    table3: 'Push Record',
    pushCountTips: 'Number of successful push/total number of pushed works',
    pushTime: 'Push Date',
  },
  ai: {
    history: {
      table: {
        taskNameId: 'Task Name and ID',
        status: 'Status',
        operations: 'Operations',
        fileCount: 'Number of Generations',
        languages: 'Language',
        duration: 'Duration',
        workNameId: 'Work Name and ID',
        download: 'Download',
        create: 'Create a Video Project',
        taskName: 'Task Name',
        taskId: 'Task ID',
        workName: 'Work Name',
        workId: 'Work ID',
      },
    },
    table: {
      status: {
        pending: 'Generating',
        success: 'Success',
        failed: 'Failure',
      },
    },
  },
}
